import { render, staticRenderFns } from "./TableAvenantArticlev2.vue?vue&type=template&id=846ec454&scoped=true&"
import script from "./TableAvenantArticlev2.vue?vue&type=script&lang=js&"
export * from "./TableAvenantArticlev2.vue?vue&type=script&lang=js&"
import style0 from "./TableAvenantArticlev2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TableAvenantArticlev2.vue?vue&type=style&index=1&id=846ec454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846ec454",
  null
  
)

export default component.exports